<template>
<div>
    <div class="dev-box" style="position:absolute; bottom:10px; left:10px; padding:10px;" v-show="deviceHelper"> <!-- PRODMODE:none DEVMODE:initial -->
      <ul style="list-style-type: none; line-height:15px; margin-left:30px">
        <li><span style="font-weight:bold">{{ uiState }}</span></li>
        <!-- <li><a href="#" @click.prevent="isLocal = true">LOCAL CLIENT</a></li> -->
        <li><input type="checkbox" id="checkbox1" v-model="isLocal"><label for="checkbox1">isLocal: {{ isLocal }}</label></li>
        <li><input type="checkbox" id="checkbox2" v-model="emgEnabled" @change="emgEnabled = $event.target.checked; examChart.emgEnable($event.target.checked)"><label for="checkbox2">emgEnable</label></li>
        <li><input type="checkbox" id="checkbox4" v-model="uaActive"><label for="checkbox4">uaActive: {{ uaActive }}</label></li>
        <li><input type="checkbox" id="checkbox5" v-model="isPositiveFound"><label for="checkbox5">isPositiveFound: {{ isPositiveFound }}</label></li>
        <li><input type="checkbox" id="checkbox3" v-model="isWarning"><label for="checkbox3">isWarning: {{ isWarning }}</label></li>
        <!-- <li><input type="checkbox" id="checkbox4" v-model="systemConfig.CalibrationNeeded"><label for="checkbox4">CalibrationNeeded: {{ systemConfig.CalibrationNeeded }}</label></li> -->
        <!-- <li><a href="#" @click.prevent="isLocal = false">REMOTE CLIENT</a></li> -->
        <li><u>workingMode</u></li>
        <li><a href="#" @click.prevent="workingMode = 'NORMAL'">NORMAL</a></li>
        <li><a href="#" @click.prevent="workingMode = 'AUTO'">AUTO</a></li>
        <li><u>uiState</u></li>
        <li><a href="#" @click.prevent="uiState = 'CONNECTING'">CONNECTING</a></li>
        <li><a href="#" @click.prevent="uiState = 'WAIT_TO_START_BARCODE'">WAIT_TO_START_BARCODE</a></li>
        <li><a href="#" @click.prevent="uiState = 'WAIT_TO_START_TOUCH'">WAIT_TO_START_TOUCH</a></li>
        <li><a href="#" @click.prevent="uiState = 'WAIT_TO_URINATE'">WAIT_TO_URINATE</a></li>
        <li><a href="#" @click.prevent="uiState = 'URINATION'">URINATION</a></li>
        <li><a href="#" @click.prevent="uiState = 'CLEANING'">CLEANING</a></li>
        <li><a href="#" @click.prevent="uiState = 'EMERGENCY'">EMERGENCY</a></li>
        <li><a href="#" @click.prevent="uiState = 'GUARD_MODE'">GUARD_MODE</a></li>
        <li><a href="#" @click.prevent="uiState = 'MANUAL_CLEANING'">MANUAL CLEANING</a></li>
        <!-- <li><a href="#" @click.prevent="uiState = 'FillingTimeout'">FillingTimeout</a></li> -->
        <!-- <li><a href="#" @click.prevent="uiState = 'EmptyingTimeout'">EmptyingTimeout</a></li> -->
        <li><u>alarmDetail</u></li>
        <li><a href="#" @click.prevent="alarmDetail = 'FillingTimeout'">FillingTimeout</a></li>
        <li><a href="#" @click.prevent="alarmDetail = 'EmptyingTimeout'">EmptyingTimeout</a></li>
        <li><u>notification</u></li>
        <li><a href="#" @click.prevent="notifTitle = 'device_ui.out_of_order'; notifMessage = 'device_ui.dont_use'">OutOfOrder</a></li>
        <li><a href="#" @click.prevent="notifTitle = 'device_ui.payment_needed'; notifMessage = 'device_ui.contact_sales'">PaymentNeeded</a></li>
        <li><a href="#" @click.prevent="notifTitle = 'device_ui.payment_needed'; notifMessage = 'device_ui.due_date'">PaymentNeededDue</a></li>
        <li><a href="#" @click.prevent="notifTitle = 'device_ui.warning_header'; notifMessage = 'device_ui.no_longer_online'">NoLongerOnline</a></li>
        <li><a href="#" @click.prevent="notifTitle = 'device_ui.calibration_needed'; notifMessage = 'device_ui.contact_technical'">CalibrationNeeded</a></li>
        <li><u>prState</u></li>
        <li><a href="#" @click.prevent="uiState = 'CLEANING'; prState = 'PRINTING'">pr PRINTING</a></li>
        <li><a href="#" @click.prevent="uiState = 'CLEANING'; prState = 'READY'">pr READY</a></li>
        <li><a href="#" @click.prevent="uiState = 'CLEANING'; prState = 'SKIPPED'">pr SKIPPED</a></li>
        <li><a href="#" @click.prevent="uiState = 'CLEANING'; prState = 'DISABLED'">pr DISABLED</a></li>
        <li><u>functions</u></li>
        <li><a href="#" @click.prevent="injectInput()">injectInput</a></li>
        <li><a href="#" @click.prevent="setFlowRate(0)">FlowRate = 0</a></li>
        <li><a href="#" @click.prevent="setFlowRate(2)">FlowRate = 2</a></li>
        <li><a href="#" @click.prevent="setFlowRate(10)">FlowRate = 10</a></li>
        <li><a href="#" @click.prevent="setFlowRate(20)">FlowRate = 20</a></li>
        <li><a href="#" @click.prevent="setFlowRate(30)">FlowRate = 30</a></li>
        <li><a href="#" @click.prevent="setFlowRate(100)">FlowRate = 100</a></li>
        <li><a href="#" @click.prevent="setFlowRate(-100)">FlowRate = -100</a></li>
        <li><a href="#" @click.prevent="circleStart(0.5)">StartProgress</a></li>
      </ul>
    </div>

  <div class="center-div" :class="{ 'of-show': !isLocal || deviceHelper }">
    <div v-show="workingMode == 'AUTO'" style="font-weight:bold; color:red; z-index:100; position:absolute; width:50%; height:50px; left:25%; top:2%; padding:5px; background-color:yellow; line-height:23px; font-family: 'Catamaran'; font-size: 18px; font-style: normal;">Auto test mode is active<br/>Please do not use the device</div>
    <div v-show="uiState == 'CONNECTING'">
      <div class="msg-box-1">
        <div class="msg-title center" v-html="$t('device_ui.please_wait') + debug"></div>
      </div>
    </div>

    <div v-show="uiState == 'WAIT_TO_START_BARCODE'">
      <div class="wmessage">
        <template v-if="deviceStatus.ip_state === 'FAIL'">W01</template>
      </div>

      <div v-show="notifTitle || notifMessage" v-bind:class="warning_notif">
        <div v-show="!isLocal" v-bind:class="warning_notif_box" class="calibration_msg_box">
          <div class="notif_title">{{ $t(notifTitle) }}</div>
          <div class="notif_msg">{{ $t(notifMessage, {due_date: notifTimebombDueDate}) }}</div>
        </div>
        <div v-show="!isLocal" class="triangle-down"></div>
        <div class="exclaimation-mark">!</div>
      </div>

      <div v-show="isLocal">
        <div v-show="!isWarning">
          <img :src="animationPath.barcode"  />
          <div class="msg-box-1">
            <div class="msg-info" v-bind:class="textDir" v-html="$t('device_ui.welcome')"></div>
            <div class="msg-title" v-bind:class="textDir" v-html="$t('device_ui.get_your_barcode_scanned')"></div>
            <div class="msg-info-mini" v-bind:class="textDir">{{ localTimeStr }}&nbsp;</div>
          </div>
        </div>
        <div v-show="isWarning">
          <div class="msg-box-3">
            <div class="msg-title center" v-html="$t('device_ui.patient_not_found')"></div>
            <div class="msg-info center" v-html="$t('device_ui.please_consult_staff')"></div>
          </div>
        </div>
      </div>

      <div v-show="!isLocal">
        <div class="msg-box-2">
          <div class="msg-info" v-bind:class="textDir" v-html="$t('device_ui.welcome')"></div>
          <div class="msg-title" v-bind:class="textDir" v-html="$t('device_ui.start_test_manually')"></div>
          <div class="msg-info-mini" v-bind:class="textDir">{{ localTimeStr }}&nbsp;</div>

          <div style="margin-top:40px; text-align:left;">

            <div v-show="!isWarning">
              <input type="text" id="barcodeNumber" @keyup.enter="startManual" />
              <input class="startManual" type="submit" :value="$t('device_ui.start_the_test')" @click.prevent="startManual" />
            </div>
            <div v-show="isWarning">
               <span class="warning" v-html="$t('device_ui.patient_not_found')"></span>
            </div>
          </div>
          <a href="/" class="msg-link left">{{ $t('result_ui.result_screen') }}</a>
        </div>
          <button v-show="systemConfig.ManualCleanEnabled && notifTag != 'clean-filter'" @click.prevent="manualCleaner" class="cleaner-button">{{ $t('device_ui.clean') }}</button>
          <button v-show="notifTag == 'clean-filter'" @click.prevent="manualCleaner" class="clean-filter">{{ $t('device_ui.filter_cleaned') }}</button>
      </div>
    </div>

    <div v-show="uiState == 'WAIT_TO_START_TOUCH'">
      <div class="wmessage">
        <template v-if="deviceStatus.ip_state === 'FAIL'">W01</template>
      </div>

      <img :src="animationPath.touch"  />
      <div class="msg-box-1">
        <div class="msg-info" v-bind:class="textDir" v-html="$t('device_ui.welcome')"></div>
        <div class="msg-title" v-bind:class="textDir" v-html="$t('device_ui.start_test_by_hand')"></div>
        <div class="msg-info-mini" v-bind:class="textDir">{{ localTimeStr }}&nbsp;</div>
      </div>
    </div>

    <div v-show="uiState == 'WAIT_TO_URINATE'">
      <div style="margin-top:65px;">
        <vue-circle
            :key="circle.resetKey"
            ref="progressCircle"
            :progress="circle.progressTo"
            :size="200"
            :reverse="false"
            line-cap="round"
            :fill="fill"
            :animation="circle.animation"
            empty-fill="rgba(0, 0, 0, .1)"
            :animation-start-value="circle.progressFrom"
            :start-angle="-(Math.PI/2.0)"
            insert-mode="append"
            :thickness="6"
            :show-percent="false"
            @vue-circle-progress="progress"
            @vue-circle-end="progress_end">
            <span style="font-size:40px; font-family:'Bebas Neue'">{{ countdown }}</span>
        </vue-circle>
      </div>
      <div class="msg-box-1">
        <div class="msg-title center" v-html="$t('device_ui.start_to_urinate')"></div>
        <div class="msg-info center" v-html="$t('device_ui.test_timeout', {sec: startTimeout})"></div>
      </div>
      <input v-show="!isLocal" class="skipExam" type="submit" :value="$t('result_ui.cancel')" @click.prevent="skipExam" />
    </div>

    <div v-show="uiState == 'EMERGENCY'">
      <div style="background-color:#FF2B39; width:544px; height:294px; margin:45px auto; border-radius: 10px; padding:5%">
        <div style="height:95%; border-radius: 10px; border:solid 4px white;">
          <img src="../assets/device-ui/WhiteCross.png" class="center-image-for-box" />
        </div>
        <div class="msg-box-3">
          <div class="msg-title center light" v-html="$t('device_ui.emergency')"></div>
          <div class="msg-info center light" v-html="$t('device_ui.please_wait')"></div>
        </div>
      </div>
    </div>

    <div v-show="uiState == 'GUARD_MODE'">
      <div class="wmessage">
        <template v-if="alarmDetail == 'FillingTimeout'">W02</template>
        <template v-if="alarmDetail == 'EmptyingTimeout'">W03</template>
        <template v-if="!alarmDetail">
          <template v-if="notifTag == 'missing-document-timebomb'">W04</template>
          <template v-if="notifTag == 'calibration-fault'">W05</template>
          <template v-if="notifTag == 'clean-filter'">W06</template>
        </template>
      </div>
      <template v-if="notifMessageDevice != 'toilet-mode'">
        <img v-show="alarmDetail || isLocal" src="../assets/device-ui/RedCross.png" class="center-image" />
      </template>
      <div class="msg-box-3">
        <template v-if="isLocal || alarmDetail">
          <template v-if="notifMessageDevice == 'toilet-mode'">
            <div class="msg-title center serious" v-html="'Lütfen peçete atmayınız'"></div>
          </template>
          <template v-if="notifMessageDevice != 'toilet-mode'">
            <div class="msg-title center serious" v-html="$t('device_ui.out_of_order')"></div>
            <div class="msg-info center" v-html="$t('device_ui.dont_use')"></div>
          </template>
        </template>
        <template v-if="!isLocal && !alarmDetail">
          <template v-if="notifMessageDevice != 'toilet-mode'">
            <div class="msg-title center serious" v-html="$t(notifTitle)"></div>
            <div class="msg-info center" v-html="$t(notifMessage)"></div>
          </template>
          <template v-if="notifMessageDevice == 'toilet-mode'">
            <div class="msg-title center serious" v-html="'Lütfen peçete atmayınız'"></div>
          </template>
        </template>
      </div>
    </div>

    <div v-show="uiState == 'URINATION'">
      <div style="height:50px; margin-bottom:25px; background-color:#dadbdc; color:#fff; text-align:right; padding-right:50px;">
          <span style="float:left; font-size:24px; margin-top:14px; margin-left:80px; color:#333">
            <template v-if="isLocal">{{ patientInfo }}</template>
            <template v-if="!isLocal">{{ patientInfoRemote }}</template>
          </span>
          <img style="margin-top:12px;" src="../assets/oruflow.png" />
      </div>
      <svg id="chartExam"></svg>
      <div v-show="emgEnabled && !isLocal" style="position:absolute; left:0; bottom:-50px; font-family:'Catamaran'">
        <label for="emgScale" >EMG Skala:&nbsp;</label>
        <select id="emgScale" @change="onChange($event)">
          <option>5</option>
          <option>10</option>
          <option>15</option>
          <option>20</option>
          <option>25</option>
          <option>30</option>
          <option>35</option>
          <option>40</option>
          <option>45</option>
          <option>50</option>
          <option>60</option>
          <option>70</option>
          <option>80</option>
          <option>90</option>
          <option>100</option>
          <option>125</option>
          <option>150</option>
          <option>175</option>
          <option selected="selected">200</option>
          <option>500</option>
          <!-- <option>1000</option> -->
        </select>
      </div>
      <button v-if="systemConfig.ManualEndExamEnabled" class="end-exam" @click.prevent="endExam">{{ $t('device_ui.end_exam') }}</button>
    </div>

    <div v-show="uiState == 'CLEANING'">

      <div v-show="isPositiveFound === false && uaActive" style="position:absolute; top:0; left:0; width:10px; height:10px; background-color:rgba(0, 255, 0, 1.0); z-index:100;">&nbsp;</div>
      <div v-show="isPositiveFound === true && uaActive" style="position:absolute; top:0; left:0; width:10px; height:10px; background-color:rgba(255, 0, 0, 1.0); z-index:100;">&nbsp;</div>
      <div v-show="isPositiveFound === null && uaActive" style="position:absolute; top:0; left:0; width:10px; height:10px; background-color:rgba(127, 127, 127, 1.0); z-index:100;">&nbsp;</div>

      <div v-show="prState == 'PRINTING'">
        <img src="../assets/device-ui/PrinterInprogress.png" class="center-image" />
        <div class="msg-box-3">
          <div class="msg-title center" v-html="$t('device_ui.wait_to_print')"></div>
        </div>
      </div>

      <div v-show="prState == 'READY'">
        <img src="../assets/device-ui/PrinterReady.gif" class="center-image" />
        <div class="msg-box-3">
          <div class="msg-title center" v-html="$t('device_ui.result_is_ready')"></div>
        </div>
      </div>

      <div v-show="prState == 'SKIPPED'">
        <img src="../assets/device-ui/LowVolume.png" class="center-image" />
        <div class="msg-box-3">
          <div class="msg-title center" v-html="$t('device_ui.insufficient_volume')"></div>
        </div>
      </div>

      <div v-show="prState == 'DISABLED'">
        <img src="../assets/device-ui/BlueTick.png" class="center-image" />
        <div class="msg-box-3">
          <div class="msg-title center" v-html="$t('device_ui.sent_to_doctor')"></div>
          <div class="msg-info center" v-html="$t('device_ui.exam_is_completed')"></div>
        </div>
      </div>
    </div>

    <div v-show="uiState == 'MANUAL_CLEANING'">
      <img src="../assets/state-ui/WAIT_TO_URINATE.gif" class="center-image droplet" />
      <img src="../assets/spinner.png" class="spinner rotating" />
      <div class="msg-title">{{ $t('device_ui.auto_cleaning')}}</div>
    </div>

  </div>

  <div class="header">
    <img src="../assets/oruflow.png">
    <div class="header-text" v-bind:class="textDir" v-html="$t('device_ui.remote_control')"></div>
  </div>
  <img src="../assets/ellipseRight.png" class="ellipse-right" />
  <img src="../assets/ellipseLeftBottom.png" class="ellipse-left-bottom" />

  <!-- <button @click="screen--"><</button>
  {{ screen }}
  <button @click="screen++">></button> -->

</div>

</template>

<script>

import ReactiveDictClient from '../ReactiveDictClient'
import GenericChart from '../GenericChart'
import Settings from '../settings'
import _ from 'lodash'

import pathFlow from '../assets/state-ui/WAIT_TO_URINATE.gif'
import pathBarcodei from '../assets/state-ui/barcode4.gif'
import pathBarcodeh from '../assets/state-ui/barcode_h.gif'
import pathTouch from '../assets/state-ui/touch_light.gif'
import pathTakepaper from '../assets/state-ui/takepaper.gif'

import VueCircle from 'vue2-circle-progress'
// import Popper from 'vue-popperjs'
// import 'vue-popperjs/dist/vue-popper.css'

const animationPath = {
  flow: pathFlow,
  takepaper: pathTakepaper,
  touch: pathTouch,
  barcode: pathBarcodei + '?' + Math.random()
}

const wsurl = (path) => 'ws://' + Settings.host + ':6161' + path
const hturl = (path) => 'http://' + Settings.host + ':6161' + path
const apiurl = 'http://' + Settings.host + ':6161/api'

export default {
  components: {
    VueCircle
  },
  data () {
    return {
      screen: -1,
      alarmDetail: '',
      notifTitle: '',
      notifMessage: '',
      notifMessageDevice: '',
      notifTimebombDueDate: '',
      notifTag: '',
      uiState: '',
      prState: '',
      isLocal: true,
      isWarning: false,
      chartVisible: false,
      patientInfo: '',
      patientInfoRemote: '',
      reloader: Math.random(),
      helperMenuDisplay: {true: 'initial', false: 'none'},
      deviceStatus: { ip_state: 'UNKNOWN' },
      deviceHelper: false,
      debug: '..',
      emgEnabled: false,
      uaActive: false,
      isPositiveFound: null,
      systemConfig: {},
      fill: { gradient: ['#00D77E', '#0061FF'] },
      circle: {
        animation: false,
        progressFrom: 0,
        progressTo: 0,
        resetKey: 0
      },
      startTimeout: 10,
      countdown: '',
      deviceClientTimeDiff: undefined,
      localTimeStr: '',
      animationPath: animationPath,
      workingMode: undefined
    }
  },
  computed: {
    textDir: function () {
      if (this.systemConfig.Language === 'he' || this.systemConfig.Language === 'ar') {
        return {
          rtl: true,
          ltr: false
        }
      } else {
        return {
          rtl: false,
          ltr: true,
          rtlNotif: false
        }
      }
    },
    warning_notif: function () {
      if (this.systemConfig.Language === 'he' || this.systemConfig.Language === 'ar') {
        return {
          warningNotifLeft: true,
          warningNotifRight: false
        }
      } else {
        return {
          warningNotifLeft: false,
          warningNotifRight: true
        }
      }
    },
    warning_notif_box: function () {
      if (this.systemConfig.Language === 'he' || this.systemConfig.Language === 'ar') {
        return {
          calibration_msg_box_left: true,
          calibration_msg_box_right: false
        }
      } else {
        return {
          calibration_msg_box_left: false,
          calibration_msg_box_right: true
        }
      }
    }
  },
  methods: {
    secondsToStr (totalSeconds) {
      var minutes = Math.floor(totalSeconds / 60)
      var minutesStr = minutes >= 10 ? minutes.toString() : '0' + minutes.toString()
      var seconds = Math.floor(totalSeconds % 60)
      var secondsStr = seconds >= 10 ? seconds.toString() : '0' + seconds.toString()
      return minutesStr + ':' + secondsStr
    },
    circleStart (from) {
      var vm = this
      var durationSeconds = vm.startTimeout - (vm.startTimeout * from)
      // vm.countdown = vm.secondsToStr(durationSeconds)
      vm.circle.animation = { duration: durationSeconds * 1000, easing: 'linear' }
      vm.circle.progressFrom = from
      vm.circle.progressTo = 100
      vm.circle.resetKey += 1
    },
    circleReset () {
      var vm = this
      vm.countdown = ''
      vm.circle.animation = false
      vm.circle.progressFrom = 0
      vm.circle.progressTo = 0
      vm.circle.resetKey += 1
    },
    progress (event, progress, stepValue) {
      var vm = this
      var totalSeconds = parseInt(vm.startTimeout - vm.startTimeout * (stepValue / 100.0), 10)
      var countdown = vm.secondsToStr(totalSeconds)
      if (vm.countdown !== countdown) vm.countdown = countdown
    },
    progress_end (event) {
      // var vm = this
      // vm.circleReset()
      console.log('Circle progress end')
    },
    onChange (event) {
      var vm = this
      console.log(event.target.value)
      let max = parseInt(event.target.value, 10)
      vm.examChart.rescaleEmg([-1 * max, max])
    },
    src (_img) {
      /*  GIF animation sources are retrieved by this function. By using this way, GIFs are reloaded everytime they appear (Math.random()).
          This is done, because webkit browsers (for example Midori) was slow while displaying the same animation second time.
          It may seem interesting, but browser may try to 'remember' the last frame shown. By reloading, it starts from the first frame (which is also good for this app)  */
      console.log('Image', _img, 'requested')
      return animationPath[_img] // + '?' + Math.random()
    },
    endExam () {
      console.log('Ending test')
      this.$http.get(apiurl + '/end_exam')
        .then((response) => { console.log(response) })
    },
    manualCleaner () {
      this.$http.get(apiurl + '/manual_cleaner')
        .then((response) => { console.log(response) })
    },
    startManual () {
      var vm = this

      var barcodeNumber = document.getElementById('barcodeNumber').value

      vm.$http.get(hturl('/action/inject_input/' + barcodeNumber))
        .then((response) => { document.getElementById('barcodeNumber').value = ''; console.log(response) }, (response) => { document.getElementById('barcodeNumber').value = ''; console.log(response) })
    },
    skipExam () {
      this.$http.get(apiurl + '/skip_exam')
        .then((response) => { console.log(response) }, (response) => { console.log(response) })
    },
    setFlowRate (flowRate) {
      var vm = this

      console.log('flow rate will be set to:', flowRate)

      vm.$http.get(hturl('/action/set_flow_rate/' + flowRate))
        .then((response) => { console.log(response) }, (response) => { console.log(response) })
    },
    injectInput () {
      var vm = this

      vm.$http.get(hturl('/action/inject_input/123456'))
        .then((response) => { console.log(response) }, (response) => { console.log(response) })
    },
    updateDisplayedNow () {
      var vm = this

      if (vm.deviceClientTimeDiff !== undefined) {
        var clientNow = new Date()
        var deviceNow = new Date(clientNow.getTime() + vm.deviceClientTimeDiff)
        // console.log('Updating time...', deviceNow.toLocaleTimeString())
        var hours = ('0' + deviceNow.getHours()).slice(-2)
        var minutes = ('0' + deviceNow.getMinutes()).slice(-2)
        vm.localTimeStr = hours + ':' + minutes
      }

      setTimeout(vm.updateDisplayedNow, 1000)
    }
  },
  created () {
    var vm = this
    window.document.title = 'ORUFLOW - ' + vm.$t('device_ui.remote_control')

    vm.updateDisplayedNow()

    console.log('Device.vue / created ()')
  },
  mounted () {
    var vm = this

    vm.deviceHelper = Settings.deviceHelper

    console.log('mounted.')

    // await vm.$http.get(apiurl + '/config').then(
    //   response => {
    //     vm.systemConfig = response.body
    //     console.log('systemConfig arrived', response.body)
    //     vm.startTimeout = parseInt(vm.systemConfig.StartUrination, 10)
    //     if (vm.systemConfig.DeviceModel === 'i') {
    //       animationPath.barcode = pathBarcodei + '?'
    //     } else if (vm.systemConfig.DeviceModel === 'h') {
    //       animationPath.barcode = pathBarcodeh + '?'
    //     } else {
    //       console.log('Error getting device model and setting animation')
    //     }
    //     console.log(animationPath.barcode)
    //   },
    //   error => {
    //     console.log('Error getting device model and setting animation, network level')
    //     console.dir(error)
    //     console.log(error.status)
    //     console.log(error.statusText)
    //   })

    var config = {
      width: 750,
      height: 384,
      // margin           : { top:8, bottom:21, left:75, right:25 },
      margin: { top: 5, bottom: 16, left: 55, right: 10 },
      interpolation: 'monotone',
      tickInterval: 1000,
      tickEvery: 5,
      // orientation      : 'vertical',

      chartType: 'dynamic',
      invisible_points: 0,
      totalTime: 19000,
      translation: vm.$t,
      lineStrokeWidth: 1.5 // should match css "stroke-width"
    }

    vm.examChart = new GenericChart(document.getElementById('chartExam'), config)

    var addr = wsurl('/websocket')

    var db = new ReactiveDictClient(addr)

    // setInterval(function () { vm.reloader = Math.random(); if (vm.uiState === 'WAIT_TO_START') vm.uiState = 'WAIT_TO_URINATE'; else vm.uiState = 'WAIT_TO_START' }, 2000)

    db.on('connecting', function () {
      vm.uiState = 'CONNECTING'
      vm.debug = '...'
    })

    db.on('connected', function () {
      vm.$http.get(apiurl + '/config').then(
        response => {
          vm.systemConfig = response.body
          console.log('systemConfig arrived', response.body)
          vm.startTimeout = parseInt(vm.systemConfig.StartUrination, 10)
          if (vm.systemConfig.DeviceModel === 'i') {
            animationPath.barcode = pathBarcodei + '?' + Math.random()
          } else if (vm.systemConfig.DeviceModel === 'h') {
            animationPath.barcode = pathBarcodeh + '?' + Math.random()
          } else {
            console.log('Error getting device model and setting animation')
          }
          console.log(animationPath.barcode)

          let defaultEMGScale = vm.systemConfig['EMG.Chart.Scale']
          let selectElement = document.getElementById('emgScale')
          let options = Array.from(selectElement.options)
          let newDomain = defaultEMGScale.uV[1]

          let existingOption = options.find(option => option.value === String(newDomain))
          if (!existingOption) {
            const newOption = document.createElement('option')
            newOption.value = newDomain
            newOption.textContent = newDomain

            selectElement.insertBefore(newOption, selectElement.firstChild)
          }
        },
        error => {
          console.log('Error getting device model and setting animation, network level')
          console.dir(error)
          console.log(error.status)
          console.log(error.statusText)
        })
      vm.debug = '.'
    })

    db.on('disconnected', function () {
      vm.debug = ''
    })

    db.on('TimesyncWatcher/deviceUtcStr', function (isnp, val) {
      console.log('TimesyncWatcher/deviceUtcStr', isnp, val)

      var clientDateUpdate = val.slice(-1) === 'T'
      var deviceUtcStr = val.slice(0, -1)
      var deviceDate = new Date(deviceUtcStr)
      var clientDate = new Date()
      var clientUtcStr = clientDate.toISOString()

      vm.deviceClientTimeDiff = deviceDate.getTime() - clientDate.getTime()

      if (clientDateUpdate) {
        console.log('ClientDateUpdate is', clientDateUpdate, 'so trying to update date if needed', Math.abs(vm.deviceClientTimeDiff))
        if (Math.abs(vm.deviceClientTimeDiff) > 10000) {
          if (confirm(vm.$t('device_ui.date_diff_warning', {device: deviceDate.toString(), client: clientDate.toString()}))) {
            db.send({'action': 'updateDateFromClient', 'clientUtcStr': clientUtcStr})
          } else {
            console.log('CDU You pressed Cancel!')
          }
        }
      } else {
        console.log('ClientDateUpdate is', clientDateUpdate, 'and systemConfig.deviceUtcStr is', deviceUtcStr)
      }
    })

    db.on('SOCKET_INFO/isLocal', function (isnp, val) {
      vm.isLocal = val
    })

    db.on('StatusController/ip_state', function (isnp, val) {
      vm.deviceStatus.ip_state = val
      console.log('deviceStatus.ip_state', val)
    })

    db.on('Examination/time_passed', function (isnp, timePassed) {
      timePassed = parseInt(timePassed, 10)
      console.log('timePassed ::', timePassed)
      if (!vm.countdown && timePassed !== -1) {
        var timePassedPercent = timePassed / vm.systemConfig.StartUrination
        console.log(timePassedPercent)
        vm.circleStart(timePassedPercent)
      }
    })

    db.on('Examination/alarm_detail', function (isnp, newState) { vm.alarmDetail = newState })
    db.on('Examination/notif_title', function (isnp, newState) { vm.notifTitle = newState })
    db.on('Examination/notif_message', function (isnp, newState) { vm.notifMessage = newState })
    db.on('Examination/notif_message_device', function (isnp, newState) {
      vm.notifMessageDevice = newState
      console.log('NotifMessageDevice:' + vm.notifMessageDevice)
    })
    db.on('Examination/notif_timebomb_due_date', function (isnp, newState) { vm.notifTimebombDueDate = newState })
    db.on('Examination/notif_tag', function (isnp, newState) {
      vm.notifTag = newState
      console.log('NotifTag' + vm.notifTag)
    })

    db.on('Examination/ui_state', function (isnp, newUiState) {
      if (vm.uiState === 'WAIT_TO_URINATE') {
        vm.circleReset()
      }

      if (newUiState === 'WAIT_TO_START_BARCODE') {
        animationPath.barcode = animationPath.barcode.replace(/\?.*/g, '?' + Math.random())
        console.log('Image barcode refreshed.')
      } else if (newUiState === 'WAIT_TO_START_TOUCH') {
        animationPath.touch = animationPath.touch.replace(/\?.*/g, '?' + Math.random())
        console.log('Image touch refreshed.')
      }

      vm.uiState = newUiState
    })

    db.on('Examination/print_status', function (isnp, st) {
      vm.prState = st
    })

    db.on('Examination/working_mode', function (isnp, st) {
      vm.workingMode = st
    })

    db.on('Examination/patient_info', function (isSnapshot, patientInfo) {
      if (patientInfo === 'WAITING ANSWER') {
        vm.patientInfoRemote = vm.$t('device_ui.waiting_for_response')
        vm.patientInfo = ''
      } else {
        vm.patientInfoRemote = patientInfo
        vm.patientInfo = patientInfo
      }

      if (!isSnapshot && vm.patientInfo === 'HASTA BULUNAMADI') {
        vm.isWarning = true
        setTimeout(() => {
          vm.isWarning = false
        }, 5000)
      }
    })

    db.on('Examination/emg_active', function (isSnapshot, isEnabled) {
      setTimeout(() => { vm.examChart.emgEnable(isEnabled); vm.emgEnabled = isEnabled }, 250) // workaround
    })

    db.on('Examination/is_positive_found', function (isSnapshot, isPositiveFound) {
      vm.isPositiveFound = isPositiveFound
    })

    db.on('Examination/ua_active', function (isSnapshot, isEnabled) {
      vm.uaActive = isEnabled
    })

    db.on('Examination/qura_vmic', function (isSnapshot, quraVmic) {
      if (isSnapshot) {
        console.log('quraVmic snapshot, initting chart...')

        var data1 = []
        var data2 = []
        var data3 = []

        // console.dir('quraVmic')
        // console.dir(quraVmic)

        var elapsed = quraVmic.elapsed
        var outputDateRate = 1
        var tickInterval = 1000 / outputDateRate

        var firstTime = elapsed - tickInterval * quraVmic.history.length

        _.each(quraVmic.history, function (v, k) {
          data1.push([new Date(firstTime), v[0]])
          data2.push([new Date(firstTime), v[1]])
          // data3.push([new Date(firstTime), v[1]])

          for (let i = 0; i < v[2].length; i++) {
            data3.push([new Date(firstTime + i * 100), v[2][i]])
          }

          firstTime += tickInterval
        })

        vm.examChart.initDrawing(data1, data2, data3, {qura: [0, 50, 10]}, {uV: [-200, 200, 50]})
        // vm.examChart.initDrawing([0], [0], [[0]])
      } else {
        console.log('quraVmic value, ticking chart...')
        vm.examChart.tick(quraVmic)
      }
    })

    db.connect()

    console.log('Device.vue / mounted ()')
  }

}
</script>

<style>
@import url('../assets/fonts/catamaran/catamaran.css');
@import url('../assets/fonts/bebas-neue/bebas-neue.css');

input[type=text] {
  border: 2px solid #0061FF;
  border-radius: 29px;
  height: 28px;

  font-family: Arial;
  font-size: 19px;
  letter-spacing: 0.04em;
  font-style: normal;
  font-weight: 700;
  padding-left: 10px;
  color: #0061FF;
  float:left;
}

.rtl {
  text-align: right;
}

.ltr {
  text-align: left;
}

.startManual {
  background-color: #00D77E;
  border:0;
  /* border: 2px solid #00D77E; */
  border-radius: 29px;
  padding:9px;

  width:160px;
  margin-left: 15px;

  /* float:right; */
  font-family: 'Catamaran';
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: center;
  color: #fff;
}

.startManual:hover {
  background-color: #00c240;
  cursor: pointer;
}

.skipExam {
  position: absolute;
  background-color: #0099FF;
  border:0;
  /* border: 2px solid #00D77E; */
  border-radius: 29px;
  padding:9px;
  bottom: 32px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;

  width:160px;
  /* margin-left: 15px; */
  /* float:right; */
  font-family: 'Catamaran';
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: center;
  color: #fff;
}

.skipExam:hover {
  background-color: #0066CC;
  cursor: pointer;
}

.spinner {
  width: 264px;
  height: 264px;
  margin-top: 70px;
  margin-bottom: 20px;
}

.droplet {
  top: 110px;
  height: 200px;
}

.center-image {
  position:absolute;
  margin-left: auto;
  margin-right: auto;
  bottom:250px;
  left:50%;
  transform: translate(-50%, 0);
}

.center-image-for-box {
  margin:30px auto;
  position: relative;
}

.rotating {
  -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}

.wmessage {
  position:absolute;
  left:0;
  top:0;
  width:100%;
  font-size:20px;
  font-family:'Courier New', Courier, monospace;
  font-weight: bold;
  /* background-color:#eee; */
  color: #d5d8dc;
  padding-top: 3px;
  padding-left: 3px;
  text-align: left;
}

.circle {
  position: absolute;
  top:0;
}

.msg-box-1 {
  /* background-color:rgba(0, 0, 0, 0.21); */
  position:absolute;
  width:75%;
  top:65%;
  left:50%;
  transform: translate(-50%, 0);
}

.msg-box-2 {
  /* background-color:rgba(0, 0, 0, 0.21); */
  position:absolute;
  width:75%;
  top:15%;
  left:50%;
  transform: translate(-50%, 0);
  z-index:-1;
}

.msg-box-3 {
  /* background-color:rgba(0, 0, 0, 0.21); */
  position:absolute;
  width:75%;
  top:50%;
  left:50%;
  transform: translate(-50%, 0);
}

.msg-link {
  color: #0061FF;
  font-family: 'Catamaran';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  margin-top: 150px;
  position:absolute;
  display: block;
}

.msg-info {
  font-family: 'Catamaran', Arial, Helvetica, sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0em;
  color: #979797;
}

.msg-info-mini {
  font-family: 'Catamaran';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 22hpx;
  letter-spacing: 0em;
  color: #979797;
  margin-top: 8px;
}

.msg-title {
  font-size: 32px;
  font-weight: 700;
  font-family: 'Catamaran', Arial, Helvetica, sans-serif;
  line-height: 40px;
  color: #0061FF;
  margin-top: 4px;
  margin-bottom: 4px;
}

.light {
  color: #fff
}

.serious {
  color: #FF2B39
}

.center {
  text-align: center;
}

.header {
  position:absolute;
  left:5%;
  top:5%;
}

.header-text {
  margin-top: 7px;
  font-size: 32px;
  font-weight: 100;
  font-family: 'Catamaran', Arial, Helvetica, sans-serif;
  color: #0061FF;
  text-transform: uppercase;
}

.header-text::first-letter {
   margin-left: -0.08em;
}

.ellipse-right {
  display: block;
  position: absolute;
  right:0;
  top:50%;
  transform: translate(0, -50%);
}

.ellipse-left-bottom {
  display: block;
  position: absolute;
  bottom:0;
  left:0;
}

.center-div {
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  width: 800px;
  height: 480px;
  background-color: #fff;
  border-radius: 3px;
  text-align: center;
  z-index: 100;

  box-shadow: 0px 0px 35px rgba(0, 36, 94, 0.12);
  border-radius: 10px;
}

.dev-box {
  font-family: Arial, Helvetica, sans-serif;
  z-index: 1000;
  font-size: 14px;
  text-align: right;
  background-color:#eee;
}

.dev-box li { padding-bottom: 5px; }

.dev-box a {
  text-decoration:none;
  color:blue;
  padding-left:10px;
}

.dev-box a:hover {
  color:#FF2B39;
}

@media screen and (min-height: 0px) and (max-height: 700px) {
  .header, .ellipse-left-bottom, .ellipse-right { display: none; }  /* show it on small screens */
  .center-div {border:none; box-shadow:none; }
  .dev-box {display: none;}
}

.of-show {
  overflow: visible;
}

.end-exam {
  background-color: #0061ff;
  color: #fff;
  cursor: pointer;
  border: 2px solid #0061ff;
  border-radius: 29px;
  padding-top:7px;
  padding-bottom:7px;
  padding-left:9px;
  padding-right:9px;

  font-family: 'Catamaran';
  font-weight: 700;
  line-height: 12px;
  letter-spacing: 0em;
  text-align: center;
  font-size: 14px;

  position: absolute;
  display: block;
  bottom: -58px;
  right: 366px;
}

.clean-filter {
  background-color: #fff;
  color: #FF2B39;
  cursor: pointer;
  border: 2px solid #FF2B39;
  border-radius: 29px;
  padding:9px;

  font-family: 'Catamaran';
  font-weight: 700;
  line-height: 12px;
  letter-spacing: 0em;
  text-align: center;
  font-size: 14px;

  position: absolute;
  display: block;
  bottom: 24px;
  right: 100px;
}

.cleaner-button {
  background-color: #fff;
  color: #0061FF;
  cursor: pointer;
  border: 2px solid #0061FF;
  border-radius: 29px;
  padding:9px;

  font-family: 'Catamaran';
  font-weight: 700;
  line-height: 12px;
  letter-spacing: 0em;
  text-align: center;
  font-size: 14px;

  position: absolute;
  display: block;
  bottom: 24px;
  right: 100px;
}

.warning {
  line-height: 34px;
  font-family: 'Catamaran';
  font-weight: 900;
  font-size:24px;
  color:#FF2B39;
}

.warningNotifLeft{
  display: block;
  position: absolute;
  top: 110px;
  left: 100px;
}

.warningNotifRight{
  display: block;
  position: absolute;
  top: 110px;
  right: 145px;
}

.exclaimation-mark {
  display: block;
  font-family: 'Catamaran';
  font-size: 28px;
  font-weight: normal;
  border-radius: 50%;
  border: 2px solid #FF2B39;
  z-index:99999;
  width: 25px;
  height: 25px;
  text-align: center;
  color: #FF2B39;
  animation: blink 3s infinite;
}

.triangle-down {
  display: block;
  position: absolute;
  bottom: 28px;
  left: 4px;
  border-bottom: 0;
  box-shadow: inset 0 0 2px 2px rgb(0, 0, 0);

  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 20px solid #FF2B39;
  animation: blink 3s infinite;
}

.calibration_msg_box_left {
  position: absolute;
  bottom: 47px;
  left: -50px;
}

.calibration_msg_box_right {
  position: absolute;
  bottom: 47px;
  right: -50px;
}

.calibration_msg_box {
  display: block;
  padding-top:10px;
  padding-bottom: 5px;
  padding-left: 5px;
  padding-right: 5px;
  z-index:99999;
  min-width: max-content;
  max-width: 450px;
  height:53px;
  border-width: 2px;
  border-radius: 10px;
  border-color: #FF2B39;
  border-style: solid;

  font-family: 'Catamaran';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  color:#FF2B39;
  animation: blink 3s infinite;
}

.notif_title {
  font-family: 'Catamaran';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px;
  letter-spacing: 0em;
  text-align: center;
  color:#FF2B39;
}

.notif_msg {
  font-family: 'Catamaran';
  line-height: 22px;
  font-size:16px;
  font-weight:700;
  color:#979797;
}

.notif_msg.sep {
  border-bottom:solid 1px #ccc;
  padding-bottom:7px;
}

.notif_shadow {
  -moz-box-shadow: rgb(58, 58, 58) 0 0 8px 0;
  -webkit-box-shadow: rgb(58, 58, 58) 0 0 8px 0;
  box-shadow: rgb(58, 58, 58) 0 0 8px 0;
  background-color: #fafafa;
  padding: 8px;
  padding-left: 16px;
  padding-right: 16px;
}

.notif_shadow .popper__arrow {
  border-color: #fafafa transparent transparent transparent !important;
  border: solid 1px #000;
}

#chartExam .axis {
  font: 10px sans-serif;
}

#chartExam .axis path,
#chartExam .axis line1, #chartExam .axis line2, #chartExam .axis line3 {
  fill: none;
  stroke: #dfdfdf;
  shape-rendering: crispEdges;
}

#chartExam .axis--x line, #chartExam .axis--y1 line, #chartExam .axis--y2 line, #chartExam .axis--y3 line {
  stroke: #dfdfdf;
}

#chartExam .line1, #chartExam .line2, #chartExam .line3 {
  fill: none;
  stroke: steelblue;
  stroke-width: 1.5px;
}

/* #chartExam .area {
  fill: none;
} */

#chartExam .area {
  fill: black;
}

@keyframes blink {
  80% {
    opacity: 1;
  }
  90% {
    opacity: 0;
  }
}

@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Device.vue